
<div class='chart-wrapper'>
	<ChartsKey />
</div>
<div class='city-charts clearfix'>

{{#each cityNames as cityName, index}}
<div class='gia-chart'>

	{{#if cityName === 'CHICAGO_IL'}}
	<div class='chicago-missing-data'>
	</div>
	<div class='chicago-missing-data-2'>
	</div>
	{{/if}}

	{{#if cityName === 'NEW ORLEANS_LA'}}
	<div class='nola-missing-data'>
	</div>
	{{/if}}
	<div class='gia-chart-title'><h2 class='city-name'>{{prettyNames[cityName]}}</h2></div>
	<div class='gia-chart-inner' style='height: {{height}}px; width{{width}}px;'>
		<svg ref:svg >
			<g class='axes'>
				<g class='axis y-axis'>
					{{#each yTicks as yTick}}
					<g class='y-ticks' transform='translate(0, {{ yScale(yTick) }})'>
						<line x1='{{ padding.left }}' x2='{{ xScale(2015) }}' y1='0' y2='0' stroke-dasharray='{{ yTick !== 0 ? "2,2" : "0,0"}}'></line>
						{{#if yTick !== 0}}
						<text x='5' y='-5'>{{addCommas(yTick)}}</text>
						{{/if}}
					</g>
					{{/each}}
				</g>
				<g class='axis x-axis'>
					<!-- make x-ticks -->
					{{#each xTicks as xTick}}
					<g
					class='axis x-ticks' transform='translate( {{ xScale(xTick) }} , {{ height - padding.bottom }} )'>
					<line class="tick" y2='3'></line>
					<text y='15' x='{{xTick === 1975 ? "1" : xTick === 2015 ? "-25" : "-15"}}'>{{xTick}}</text>
				</g>
				{{/each}}
			</g>
		</g>

		<g class='lines'>
			{{#each groups as group}}
			<path class='line {{group}}' d='{{makePath(group, xScale, yScale, years, city_murders[cityName]) }}'></path>
			{{/each}}
		</g>

	</svg>
</div>

</div>
{{ #if (index === 2) && (width > 500) }}
<div class='clearfix'>

</div>
{{/if}}
{{/each}}
</div>


<style>
.chicago-missing-data {
	width: 12.5%;
	height: 210px;
	background-color: #eaeaea;
	position: absolute;
	top: 51px;
	left: 21%;
	opacity: .5;
}
.chicago-missing-data-2 {
	width: 5%;
	height: 210px;
	background-color: #eaeaea;
	position: absolute;
	top: 51px;
	left: 62%;
	opacity: .5;
}

.nola-missing-data {
	width: 5%;
	height: 210px;
	background-color: #eaeaea;
	position: absolute;
	top: 51px;
	left: 38%;
	opacity: .5;
}
.chart-wrapper {
	/*position: absolute;*/
	top: 10px;
	right: 0;
}

.city-charts {
	margin: 0 auto;
	margin-bottom: 50px;
	max-width: 900px;
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
}

.city-name {
	font-family: 'Guardian Egyptian Web';
	font-weight: 900;
	font-size: 18px;
	margin-bottom: 10px;
}

.clearfix:after {
   content: ".";
   visibility: hidden;
   display: block;
   height: 0;
   clear: both;
}

h3 {
	font-size: 15px;
	margin: 0px;
	padding: 0px;
	line-height: 20px;
}

.gia-chart {
	/*float: auto;*/
	/*width: 100%;*/
	/*max-width: 250px;*/
	max-height: 250px;
	width: 100%;
	/*max-width: 250px;*/
	margin: 20px 0;
	padding-top: 5px;
	/*border-top: solid 2px #c05303;*/
	/*float: left;*/
	position: relative;
}

.gia-chart-inner svg {
	position: relative;
	width: 100%;
	height: 100%;
}

.line {
	stroke: #333333;
	opacity: .8;
	stroke-width: 2;
	fill: none;
}

.black_man {
	stroke: #c05303;
}

.white_man {
	stroke: #507892;
}

.black_woman {
	stroke: #dc8655;
}

.white_woman {
	stroke: #a7b9c8;
}

.light {
	stroke: #bdbdbd;
	stroke-width: 1;
}

.axis {
	font-family: 'Guardian Text Sans Web', Arial, sans-serif;
	font-size: 12px;
	font-weight: 500;
}

.axis line {
	stroke-width: .5;
	fill: none;
	stroke: #cdcdcd;
}

.axis text {
	fill: #767676;
}

.total {
	stroke: transparent;
}

@media(min-width:599px) {
	.gia-chart {
		margin: 30px 20px;
		width: 250px;
		height: 250px;
	}

	.chicago-missing-data {
		width: 29px;
		left: 56px;
	}

	.chicago-missing-data-2 {
		width: 12px;
		left: 154px;
	}

	.nola-missing-data {
		width: 12px;
		left: 96px;
	}
}

</style>

<script>
import { linearScale, addCommas } from 'gia-toolkit';
import city_murders from '../data/six_cities_counts.json';
import ChartsKey from './ChartsKey.html';

const cityNames = [ 'ST LOUIS_MO', 'NEW YORK_NY', 'BALTIMORE_MD', 'CHICAGO_IL', 'OAKLAND_CA', 'NEW ORLEANS_LA',   ];
const prettyNames = {
	'ST LOUIS_MO': 'St Louis, Missouri',
	'BALTIMORE_MD': 'Baltimore, Maryland',
	'CHICAGO_IL': 'Chicago, Illinois',
	'NEW ORLEANS_LA': 'New Orleans, Louisiana',
	'NEW YORK_NY': 'New York, New York',
	'OAKLAND_CA': 'Oakland, California'
};
// const cityData = city_murders[ cityName ];

const padding = {
	top: 15,
	right: 10,
	bottom: 25,
	left: 10
};

const years = [ '1976', '1977', '1978', '1979', '1980', '1981', '1982', '1983', '1984', '1985', '1986', '1987', '1988', '1989', '1990', '1991', '1992', '1993', '1994', '1995', '1996', '1997', '1998', '1999', '2000', '2001', '2002', '2003', '2004', '2005', '2006', '2007', '2008', '2009', '2010', '2011', '2012', '2013', '2014', '2015' ];

export default {
	data () {
		return {
			padding,
			height: 250,
			width: 250,
			xTicks: [ 1975, 1995, 2015 ],
			yTicks: [ 0, 200, 400, 600, 800 ],
			groups: [ 'total', 'black_woman', 'black_man', 'white_man', 'white_woman' ],
			upperBound: 90,
			addCommas,
			years,
			cityNames,
			city_murders,
			prettyNames,

		};
	},
	//
	// helpers: {
	// 	console
	// },
	onrender () {
		this.container = this.refs.svg;
		const self = this;

		window.addEventListener( 'resize', () => {
			self.resize();
		});

		this.resize();
	},

	computed: {
		xScale: ( width ) => linearScale([ 1975, 2015 ], [ padding.left, width - padding.right ]),
		yScale: ( height ) => linearScale([ 0, 800 ], [ height - padding.bottom, padding.top ])
	},

	methods: {
		resize () {
			this.set({
				width: this.container.getBoundingClientRect().width
				// height: this.container.getBoundingClientRect().height
			});

		},
	},
	helpers: {
		makePath ( group, xScale, yScale, years, cityData ) {

			let path = '';

			for ( let i = 0; i < years.length; i += 1 ) {
				// console.log(cityData[years[i]])
				if ( ( years[ i ] in cityData ) && ( 'counts' in cityData[ years[ i ] ]) ) {
					if ( i === 0 ) {
						path += 'M ' + xScale( +years[i]) + ' ' + yScale(cityData[years[i]]['counts'][group]) + ' '
					}

					else if ( !(years[ i - 1 ] in cityData) ||  !( 'counts' in cityData[ years[ i - 1 ] ])) {
						path += 'M ' + xScale( +years[i]) + ' ' + yScale(cityData[years[i]]['counts'][group]) + ' '
					}

					else if ( !(years[ i ] in cityData) ||  !( 'counts' in cityData[ years[ i ] ])) {

					}

					else {
						path += 'L ' + xScale( +years[i]) + ' ' + yScale(cityData[years[i]]['counts'][group]) + ' '
					}
				}
			}

			return path;
		},
		console
	},
	components: {
		ChartsKey
	}
};

</script>
